<template>
  <div class="container">
    <div v-if="loading">
      <spinner />
    </div>
    <div v-else>
      <link v-if="customStyles.stylesheet" rel="stylesheet" :href="customStyles.stylesheet" />
      <div v-if="event.applicationsOpen">
        <div
          v-if="!showForm"
          class="grid-container"
          :style="
            event.extraModules.ticketing ? 'justify-content:flex-end' : 'justify-content:center'
          "
        >
          <div v-if="event.cover && activeStep !== 3" class="event-cover">
            <img :src="event.cover" alt="cover image" />
          </div>
          <card-header-cover
            v-if="activeStep !== 3"
            :event="event"
            :style="{
              backgroundColor: getThemeStyle(event.coverImagePrimaryColor, 0.05),
            }"
            class="overflow-card"
          />

          <main :class="[activeStep !== 3 && 'main-row', !event.cover && 'main-no-image']">
            <div class="ticket-list-container">
              <attendee-data
                v-if="activeStep === 1"
                :event="event"
                :schema="schema"
                :styles="customStyles.attendeeForm"
                :initial-values="form.attendee"
                @next="
                  form.attendee = $event
                  event.extraModules.workshops ? next() : submitStepper()
                "
                @submit="
                  form.attendee = $event
                  activeStep = 3
                  submitStepper()
                "
              />
              <workshops-list
                v-if="activeStep === 2 && event.extraModules.workshops"
                :event="event"
                :selected="form.workshops"
                :workshops="event.workshops"
                :styles="customStyles.workshopsForm"
                :attendee="form.attendee"
                @back="
                  form.workshops = $event
                  activeStep = 1
                "
                @submit="
                  form.workshops = $event
                  submitStepper()
                "
              />
            </div>
          </main>
        </div>
        <v-layout v-if="activeStep === 3" justify-center>
          <v-flex v-if="event.id !== '1714'" shrink class="registration-success-page">
            <img
              class="info-image"
              src="../../../../public/assets/mail_success.svg"
              alt="mail_successful"
            />
            <div class="my-page-title">
              <span v-if="customStyles.base && customStyles.base.submitNote">{{
                customStyles.base.submitNote
              }}</span>
              <span v-else>{{ $t('editSuccess') }}</span>
            </div>
            <div v-if="customStyles.base && customStyles.base.submitInfo" class="description">
              {{ customStyles.base.submitInfo }}
            </div>
            <div v-else class="description">
              {{ $t('registrationDescription') }}
            </div>
          </v-flex>
          <v-flex v-else>
            <p class="description" style="font-family: NouvelR-Regular">
              Thank you for contacting us. You will receive a reply in a timely matter.
            </p>
          </v-flex>
        </v-layout>
        <simple-snackbar :open.sync="showError" color="primary" :message-prop="snackbarMessage" />
      </div>
      <simple-snackbar
        :open.sync="snackbarOpen"
        :message-prop="$t('aplicationSuccessful')"
        color="primary"
      />
    </div>
  </div>
</template>

<script>
import {
  GET_ATTENDEE_BY_UUID,
  UPDATE_ATTENDEE_BY_UUID,
} from '../../../graphql/accreditation.graphql'
import Spinner from './../../shared/spinner'
import AttendeeData from '../register-stepper/attendee-data.vue'
import WorkshopsList from '../register-stepper/workshops-list.vue'
import SimpleSnackbar from '../../shared/snackbars/simple-snackbar.vue'
import { createAttendeeSchema } from '../../../utils'
import CardHeaderCover from '../../shared/card-header-cover.vue'
import i18next from 'i18next'
import { CHECK_IF_ATTENDEE_ALREADY_EXISTS } from '@/graphql/event.graphql'

export default {
  name: 'edit-attendee-data',
  components: {
    Spinner,
    AttendeeData,
    SimpleSnackbar,
    CardHeaderCover,
    WorkshopsList,
  },
  props: {
    eventSlug: {
      type: String,
      default: null,
    },
    attendeeUUID: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    showForm: false,
    activeStep: 1,
    event: null,
    form: {
      attendee: {},
      workshops: [],
    },
    showError: false,
    customStyles: {},
    schema: {},
    snackbarOpen: false,
    snackbarMessage: '',
    loading: true,
    order: null,
  }),
  apollo: {
    getAttendeeByUUID: {
      query: GET_ATTENDEE_BY_UUID,
      variables() {
        return {
          attendeeUUID: this.attendeeUUID,
          eventSlug: this.eventSlug,
        }
      },
      manual: true,
      async result({ loading, data }) {
        if (!loading) {
          const { getAttendeeByUUID } = data
          if (getAttendeeByUUID.event.translation) {
            for (const translation in getAttendeeByUUID.event.translation.translationsJSON) {
              i18next.addResourceBundle(
                translation,
                'default',
                getAttendeeByUUID.event.translation.translationsJSON[translation],
                true,
                false,
              )
            }
          }
          this.event = getAttendeeByUUID.event
          this.customStyles =
            (this.event.eventUtils &&
              this.event.eventUtils.inviteFormStyles &&
              this.event.eventUtils.inviteFormStyles) ||
            {}

          this.schema = createAttendeeSchema(this.event.attendeeFields)
          this.form = {
            attendee: {
              ...getAttendeeByUUID.fields,
              category: getAttendeeByUUID.categoryId,
            },
            workshops: getAttendeeByUUID.workshops.map(({ id }) => id),
          }
          this.loading = false
        }
      },
    },
  },

  methods: {
    async next() {
      const checkIfAttendeeAlreadyExists =
        [2341].includes(Number(this.event.id)) && (await this.checkAttendeeExists())
      if (checkIfAttendeeAlreadyExists) {
        this.showError = true
        this.snackbarMessage =
          'Sudionik s ovom adresom e-pošte već se prijavio za događaj. Vaš potvrdni mail prijave ponovno Vam je poslan. Molimo provjerite inbox Vaše e-pošte.'

        return
      }
      this.activeStep = 2
    },
    async checkAttendeeExists() {
      const { data } = await this.$apollo.query({
        query: CHECK_IF_ATTENDEE_ALREADY_EXISTS,
        variables: {
          eventId: this.event.id,
          attendee: {
            email: this.form.attendee.Email,
            firstName: this.form.attendee['First name'].trim(),
            lastName: this.form.attendee['Last name'].trim(),
          },
        },
      })
      return data.checkIfAttendeeAlreadyExistsOnEvent
    },
    async submitStepper() {
      await this.$apollo.mutate({
        mutation: UPDATE_ATTENDEE_BY_UUID,
        variables: {
          attendeeUUID: this.attendeeUUID,
          attendeeData: this.form.attendee,
          selectedWorkshopsIds: this.form.workshops,
        },
      })
      this.showForm = true
      this.activeStep = 3
    },
  },
}
</script>

<style scoped>
.container {
  min-height: 100%;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.card-header-container {
  margin-bottom: 48px;
}
.event-cover {
  background-size: cover;
  border-radius: 8px 8px 0 0;
  font-size: 0;
  display: flex;
}

@supports not (aspect-ratio: 16/9) {
  .event-cover {
    position: relative;
    height: 0;
    padding-top: 33.33333%;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.event-cover img {
  aspect-ratio: 16/9;
  object-fit: cover;
  width: 100%;
  border-radius: 8px 8px 0 0;
}

.cover-header-noTicket {
  margin: 150px 0 0 50px;
  height: auto;
}
.my-page-title {
  font-family: Raleway, serif;
  font-style: normal;
  font-weight: bold;
  text-align: center;
  font-size: 38px;
  line-height: 45px;
  color: #ff4c00;
  margin-bottom: 24px;
  margin-top: 60px;
}
.description {
  font-family: Source Sans Pro, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 23px;
  text-align: center;
  color: #333333;
}
.card-header-container {
  margin-bottom: 48px;
}
.registration-success-page {
  max-width: 640px !important;
  align-items: center;
  margin: 120px 20px 0 20px;
  display: flex;
  flex-direction: column;
}
.info-image {
  width: 100%;
}

.ticket-list-container {
  margin-right: 30px;
}

/* layout */

.grid-container::before {
  content: '';
  grid-row: 1/-1;
}

.grid-container {
  max-width: 1440px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 366px) minmax(50%, 692px) minmax(25%, 366px);
  grid-template-rows: min-content min-content max-content;
}

/* .event-content-container {
  grid-column: 3;
  grid-row: 1;
  display: flex;
  flex-direction: column;
} */

.event-cover {
  grid-column: 3;
  grid-row: 1;
}

.overflow-card {
  grid-column: 3;
}

.cover-header-style {
  grid-column: 3;
}

main {
  grid-column: 2 / 3;
  grid-row: 1 / -1;
}

.main-no-image {
  grid-column: 2 / 3;
}

@media screen and (max-width: 992px) and (min-width: 801px) {
  .main-no-image {
    margin: 0 1.5rem;
  }
}
@media screen and (max-width: 992px) {
  .event-cover {
    display: none !important;
    grid-column: 1;
  }

  .register-layout {
    flex-direction: column-reverse;
  }
  .cover-header-noTicket {
    margin: 0;
  }
  .grid-container {
    grid-template-columns: 1fr;
  }
  .overflow-card {
    grid-column: 1;
    grid-row: 1;
  }
  main {
    grid-column: 1;
    grid-row: 2;
  }
  .main-no-image {
    grid-column: 1;
    grid-row: 2;
  }

  .cover-header-style {
    margin: 0;
    grid-column: 1;
  }
  .ticket-list-container {
    margin-right: 0;
  }
}

@media screen and (max-width: 375px) {
  .cover-header-style {
    width: 250px;
    margin: 0 auto;
  }
}
</style>
